export const tabProfile  = [
  {
      title: "ทะเบียนบุคลากร",
      icon: "cup",
      slugProfile: "payment",
      tabs: [
        {
          title: "การจ่ายเงิน",
          name: "TAX_1"
        },
        {
          title: "กองทุนสำรองเลี้ยงชีพ",
          name: "TAX_2"
        },
        {
          title: "รายได้-รายหักประจำปี",
          name: "TAX_3"
        },
      ]
  },
  {
    title: "ข้อมูลภาษี",
    icon: "cup",
    slugProfile: "tax",
    tabs: [
      {
          title: "ค่าลดหย่อนภาษี",
          name: "TAX_1"
      },
      {
          title: "ค่าลดหย่อนบิดา-มารดา",
          name: "TAX_2"
      },
      {
          title: "ค่าลดหย่อนคนพิการ",
          name: "TAX_3"
      },
    ]
  },
  {
    title: "ข้อมูลสิทธิ",
    icon: "cup",
    slugProfile: "personalInformation",
    tabs: [
      {
        title: "ข้อมูลสิทธิ",
        name: "TAX_1"
      },
    ]
  },
  {
    title: "ข้อมูลสิทธิ",
    icon: "cup",
    slugProfile: "rights",
    tabs: [
      {
        title: "ข้อมูลสิทธิ",
        name: "TAX_1"
      },
    ]
  },
]

export const inputTax = 
{
  'tax_1':
  {
    form:[
      {
        name:'form1',
        title: '1. สถานภาพ',
        checkArray:'fetchProfile',
        formValue:[
            {
              label: "",
              keyMapdata: ["maritalStatus"],
              typeData: "",
              value: '',
              col: 12,
              offset:0,
              checkValue:[
                "โสด",
                "สมรส",
                "หย่า",
                "หม้าย"
              ],
          },
        ]
      },
      {
        name:'form2',
        title: '2. สถานะการมีเงินได้ของคู่สมรส',
        checkArray:'fetchEmployeeTax',
        formValue:[
            {
              label: "",
              keyMapdata: ["isTwoBenefits"],
              typeData: "",
              value: '',
              col: 12,
              offset:0,
              checkValue:[
                "มีเงินได้ฝ่ายเดียว",
                "มีเงินได้ทั้งสองฝ่าย",
              ],
          },
        ]
      },
      {
        name:'form4',
        title: '3. จํานวนบุตรรวม (ที่ใช้สิทธิลดหย่อน)',
        checkArray:'detailTax',
        borderShow:true,
        borderTop:false,
        ketForm: null,
        formValue:[
          {
            label: "จำนวนบุตรที่เกิดก่อนปี 61",
            keyMapdata: ["childBirthBefore2561"],
            typeData: "",
            value: '',
            col: 12,
            offset:0,
            checkValue:[],
          },
          {
            label: "จำนวนบุตรที่เกิดหลังปี 61",
            keyMapdata: ["childBirthAfter2561"],
            typeData: "",
            value: '',
            col: 12,
            offset:0,
            checkValue:[],
          },
          {
            label: "จำนวนบุตรบุญธรรม",
            keyMapdata: ["adoptedChild"],
            typeData: "",
            value: '',
            col: 12,
            offset:0,
            checkValue:[],
          },
        ]
      },
      // {
      //   name:'form9',
      //   title: '4. ค่าฝากครรภ์และค่าคลอดบุตร',
      //   checkArray:"fetchEmployeeTax",
      //   borderShow:true,
      //   borderTop:false,
      //   ketForm: null,
      //   formValue:[
      //     {
      //       label: "ใช้สิทธิหักลดหย่อน",
      //       keyMapdata: ["reducePregnancy"],
      //       typeData: "money",
      //       value: '',
      //       col: 12,
      //       offset:0,
      //       checkValue:[],
      //   },
      //   ]
      // },
      {
        name:'form5',
        title: '5. ค่าอุปการะเลี้ยงดูบิดา',
        checkArray:"fetchEmployeeFamilyTax",
        borderShow:false,
        borderTop:false,
        ketForm: null,
        formValue:[
          {
            label: "คำนำหน้า",
            keyMapdata: ["fatherTitle"],
            typeData: "",
            value: '',
            col: 4,
            offset:0,
            checkValue:[],
          },
          {
              label: "ชื่อบิดา",
              keyMapdata: ["fatherFname"],
              typeData: "",
              value: '',
              col: 8,
              offset:0,
              checkValue:[],
          },
          {
            label: "นามสกุล",
            keyMapdata: ["fatherLname"],
            typeData: "",
            value: '',
            col: 12,
            offset:0,
            checkValue:[],
        },
          {
              label: "บัตรประชาชน",
              keyMapdata: ["fatherIdentNo"],
              typeData: "",
              value: '',
              col: 12,
              offset:0,
              checkValue:[],
          },
          {
            label: "ใช้สิทธิหักลดหย่อน",
            keyMapdata: ["fatherReduAmnt"],
            typeData: "money",
            value: '',
            col: 12,
            offset:0,
            checkValue:[],
        },
        ]
      },
      {
        name:'form8',
        title: '5.1 เบี้ยประกันสุขภาพบิดา',
        checkArray:"fetchEmployeeTax",
        borderShow:true,
        borderTop:false,
        ketForm: null,
        formValue:[
          {
            label: "ใช้สิทธิหักลดหย่อน",
            keyMapdata: ["fatherHealthInsurance"],
            typeData: "money",
            value: '',
            col: 12,
            offset:0,
            checkValue:[],
        },
        ]
      },
      {
        name:'form6',
        title: '6. ค่าอุปการะเลี้ยงดูมารดา',
        checkArray:"fetchEmployeeFamilyTax",
        borderShow:false,
        borderTop:false,
        ketForm: null,
        formValue:[
          {
            label: "คำนำหน้า",
            keyMapdata: ["motherTitle"],
            typeData: "",
            value: '',
            col: 4,
            offset:0,
            checkValue:[],
          },
          {
              label: "ชื่อมารดา",
              keyMapdata: ["motherFname"],
              typeData: "",
              value: '',
              col: 8,
              offset:0,
              checkValue:[],
          },
          {
            label: "นามสกุล",
            keyMapdata: ["motherLname"],
            typeData: "",
            value: '',
            col: 12,
            offset:0,
            checkValue:[],
        },
          {
              label: "บัตรประชาชน",
              keyMapdata: ["motherIdentNo"],
              typeData: "",
              value: '',
              col: 12,
              offset:0,
              checkValue:[],
          },
          {
            label: "ใช้สิทธิหักลดหย่อน",
            keyMapdata: ["motherReduAmnt"],
            typeData: "money",
            value: '',
            col: 12,
            offset:0,
            checkValue:[],
        },
        ]
      },
      {
        name:'form9',
        title: '6.1 เบี้ยประกันสุขภาพมารดา',
        checkArray:"fetchEmployeeTax",
        borderShow:true,
        borderTop:false,
        ketForm: null,
        formValue:[
          {
            label: "ใช้สิทธิหักลดหย่อน",
            keyMapdata: ["matherHealthInsurance"],
            typeData: "money",
            value: '',
            col: 12,
            offset:0,
            checkValue:[],
        },
        ]
      },
      {
        name:'form5',
        title: '7. ค่าอุปการะเลี้ยงดูบิดา (ของคู่สมรส)',
        checkArray:"fetchEmployeeTax",
        borderShow:false,
        borderTop:false,
        ketForm: null,
        formValue:[
          {
            label: "คำนำหน้า",
            keyMapdata: ["spouFatherTitle"],
            typeData: "",
            value: '',
            col: 4,
            offset:0,
            checkValue:[],
          },
          {
              label: "ชื่อบิดา",
              keyMapdata: ["spouFatherFname"],
              typeData: "",
              value: '',
              col: 8,
              offset:0,
              checkValue:[],
          },
          {
            label: "นามสกุล",
            keyMapdata: ["spouFatherLname"],
            typeData: "",
            value: '',
            col: 12,
            offset:0,
            checkValue:[],
        },
          {
              label: "บัตรประชาชน",
              keyMapdata: ["spouFatherIdentNo"],
              typeData: "",
              value: '',
              col: 12,
              offset:0,
              checkValue:[],
          },
          {
            label: "ใช้สิทธิหักลดหย่อน",
            keyMapdata: ["spouFatherReduAmnt"],
            typeData: "money",
            value: '',
            col: 12,
            offset:0,
            checkValue:[],
        },
        ]
      },
      {
        name:'form8',
        title: '7.1 เบี้ยประกันสุขภาพบิดา (ของคู่สมรส)',
        checkArray:"fetchEmployeeTax",
        borderShow:true,
        borderTop:false,
        ketForm: null,
        formValue:[
          {
            label: "ใช้สิทธิหักลดหย่อน",
            keyMapdata: ["spouFaHealthInsurance"],
            typeData: "money",
            value: '',
            col: 12,
            offset:0,
            checkValue:[],
        },
        ]
      },
      {
        name:'form6',
        title: '8. ค่าอุปการะเลี้ยงดูมารดา (ของคู่สมรส)',
        checkArray:"fetchEmployeeTax",
        borderShow:false,
        borderTop:false,
        ketForm: null,
        formValue:[
          {
            label: "คำนำหน้า",
            keyMapdata: ["spouMotherTitle"],
            typeData: "",
            value: '',
            col: 4,
            offset:0,
            checkValue:[],
          },
          {
              label: "ชื่อมารดา",
              keyMapdata: ["spouMotherFname"],
              typeData: "",
              value: '',
              col: 8,
              offset:0,
              checkValue:[],
          },
          {
            label: "นามสกุล",
            keyMapdata: ["spouMotherLname"],
            typeData: "",
            value: '',
            col: 12,
            offset:0,
            checkValue:[],
        },
          {
              label: "บัตรประชาชน",
              keyMapdata: ["spouMotherIdentNo"],
              typeData: "",
              value: '',
              col: 12,
              offset:0,
              checkValue:[],
          },
          {
            label: "ใช้สิทธิหักลดหย่อน",
            keyMapdata: ["spouMotherReduAmnt"],
            typeData: "money",
            value: '',
            col: 12,
            offset:0,
            checkValue:[],
        },
        ]
      },
      {
        name:'form9',
        title: '8.1 เบี้ยประกันสุขภาพมารดา (ของคู่สมรส)',
        checkArray:"fetchEmployeeTax",
        borderShow:true,
        borderTop:false,
        ketForm: null,
        formValue:[
          {
            label: "ใช้สิทธิหักลดหย่อน",
            keyMapdata: ["spouMaHealthInsurance"],
            typeData: "money",
            value: '',
            col: 12,
            offset:0,
            checkValue:[],
        },
        ]
      },
      // {
      //   name:'form10',
      //   title: '9. ค่าอุปการะเลี้ยงดู คนพิการหรือคนทุพพลภาพ (คน)',
      //   borderShow:false,
      //   borderTop:false,
      //   ketForm: null,
      //   checkArray:"detailTax",
      //   formValue:[
      //     {
      //         label: "สิทธิเลี้ยงดู คนพิการหรือคนทุพพลภาพ",
      //         keyMapdata: ["isSponserDisabled"],
      //         typeData: "",
      //         value: '',
      //         col: 12,
      //         offset:0,
      //         checkValue:[
      //           "มี",
      //           "ไม่มี",
      //         ],
      //     },
      //     {
      //         label: "จำนวนคนพิการหรือคนทุพพลภาพที่อุปการะเลี้ยงดู",
      //         keyMapdata: ["isNumberOfDisabled"],
      //         typeData: "",
      //         value: '',
      //         col: 12,
      //         offset:0,
      //         checkValue:[],
      //     },
      //   ]
      // },
      // {
      //   name:'form9',
      //   title: '9.1 ค่าอุปการะเลี้ยงดู คนพิการหรือคนทุพพลภาพคนที่ 1',
      //   borderShow:true,
      //   borderTop:false,
      //   ketForm: 1,
      //   checkArray:"detailTax",
      //   formValue:[
      //       {
      //           label: "ชื่อ - นามสกุล",
      //           keyMapdata: ["employeeName1"],
      //           typeData: "",
      //           value: '',
      //           col: 12,
      //           offset:0,
      //           checkValue:[],
      //       },
      //       {
      //           label: "บัตรคนพิการ",
      //           keyMapdata: ["idCardDisabled1"],
      //           typeData: "",
      //           value: '',
      //           col: 12,
      //           offset:0,
      //           checkValue:[],
      //       },
      //       {
      //           label: "ใช้สิทธิหักลดหย่อน",
      //           keyMapdata: ["lessAllowance1"],
      //           typeData: "money",
      //           value: '',
      //           col: 12,
      //           offset:0,
      //           checkValue:[],
      //       },
      //       {
      //         label: "ความสัมพันธ์",
      //         keyMapdata: ["relation1"],
      //         typeData: "listDropDrownRealtion",
      //         value: '',
      //         col: 12,
      //         offset:0,
      //         checkValue:[],
      //     },
      //   ]
      // },
      // {
      //   name:'form9',
      //   title: '9.2 ค่าอุปการะเลี้ยงดู คนพิการหรือคนทุพพลภาพคนที่ 2',
      //   borderShow:true,
      //   borderTop:false,
      //   ketForm: 2,
      //   checkArray:"detailTax",
      //   formValue:[
      //       {
      //           label: "ชื่อ - นามสกุล",
      //           keyMapdata: ["employeeName2"],
      //           typeData: "",
      //           value: '',
      //           col: 12,
      //           offset:0,
      //           checkValue:[],
      //       },
      //       {
      //           label: "บัตรคนพิการ",
      //           keyMapdata: ["idCardDisabled2"],
      //           typeData: "",
      //           value: '',
      //           col: 12,
      //           offset:0,
      //           checkValue:[],
      //       },
      //       {
      //           label: "ใช้สิทธิหักลดหย่อน",
      //           keyMapdata: ["lessAllowance2"],
      //           typeData: "money",
      //           value: '',
      //           col: 12,
      //           offset:0,
      //           checkValue:[],
      //       },
      //       {
      //         label: "ความสัมพันธ์",
      //         keyMapdata: ["relation2"],
      //         typeData: "listDropDrownRealtion",
      //         value: '',
      //         col: 12,
      //         offset:0,
      //         checkValue:[],
      //     },
      //   ]
      // },
      // {
      //   name:'form9',
      //   title: '9.3 ค่าอุปการะเลี้ยงดู คนพิการหรือคนทุพพลภาพคนที่ 3',
      //   borderShow:true,
      //   borderTop:false,
      //   ketForm: 3,
      //   checkArray:"detailTax",
      //   formValue:[
      //       {
      //           label: "ชื่อ - นามสกุล",
      //           keyMapdata: ["employeeName3"],
      //           typeData: "",
      //           value: '',
      //           col: 12,
      //           offset:0,
      //           checkValue:[],
      //       },
      //       {
      //           label: "บัตรคนพิการ",
      //           keyMapdata: ["idCardDisabled3"],
      //           typeData: "",
      //           value: '',
      //           col: 12,
      //           offset:0,
      //           checkValue:[],
      //       },
      //       {
      //           label: "ใช้สิทธิหักลดหย่อน",
      //           keyMapdata: ["lessAllowance3"],
      //           typeData: "money",
      //           value: '',
      //           col: 12,
      //           offset:0,
      //           checkValue:[],
      //       },
      //       {
      //         label: "ความสัมพันธ์",
      //         keyMapdata: ["relation3"],
      //         typeData: "listDropDrownRealtion",
      //         value: '',
      //         col: 12,
      //         offset:0,
      //         checkValue:[],
      //     },
      //   ]
      // },
      // {
      //   name:'form9',
      //   title: '9.4 ค่าอุปการะเลี้ยงดู คนพิการหรือคนทุพพลภาพคนที่ 4',
      //   borderShow:true,
      //   borderTop:false,
      //   ketForm: 4,
      //   checkArray:"detailTax",
      //   formValue:[
      //       {
      //           label: "ชื่อ - นามสกุล",
      //           keyMapdata: ["employeeName4"],
      //           typeData: "",
      //           value: '',
      //           col: 12,
      //           offset:0,
      //           checkValue:[],
      //       },
      //       {
      //           label: "บัตรคนพิการ",
      //           keyMapdata: ["idCardDisabled4"],
      //           typeData: "",
      //           value: '',
      //           col: 12,
      //           offset:0,
      //           checkValue:[],
      //       },
      //       {
      //           label: "ใช้สิทธิหักลดหย่อน",
      //           keyMapdata: ["lessAllowance4"],
      //           typeData: "money",
      //           value: '',
      //           col: 12,
      //           offset:0,
      //           checkValue:[],
      //       },
      //       {
      //         label: "ความสัมพันธ์",
      //         keyMapdata: ["relation4"],
      //         typeData: "listDropDrownRealtion",
      //         value: '',
      //         col: 12,
      //         offset:0,
      //         checkValue:[],
      //     },
      //   ]
      // },
      // {
      //   name:'form9',
      //   title: '9.5 ค่าอุปการะเลี้ยงดู คนพิการหรือคนทุพพลภาพคนที่ 5',
      //   borderShow:true,
      //   borderTop:false,
      //   ketForm: 5,
      //   checkArray:"detailTax",
      //   formValue:[
      //     {
      //         label: "ชื่อ - นามสกุล",
      //         keyMapdata: ["employeeName5"],
      //         typeData: "",
      //         value: '',
      //         col: 12,
      //         offset:0,
      //         checkValue:[],
      //     },
      //     {
      //         label: "บัตรคนพิการ",
      //         keyMapdata: ["idCardDisabled5"],
      //         typeData: "",
      //         value: '',
      //         col: 12,
      //         offset:0,
      //         checkValue:[],
      //     },
      //     {
      //         label: "ใช้สิทธิหักลดหย่อน",
      //         keyMapdata: ["lessAllowance5"],
      //         typeData: "money",
      //         value: '',
      //         col: 12,
      //         offset:0,
      //         checkValue:[],
      //     },
      //     {
      //       label: "ความสัมพันธ์",
      //       keyMapdata: ["relation5"],
      //       typeData: "listDropDrownRealtion",
      //       value: '',
      //       col: 12,
      //       offset:0,
      //       checkValue:[],
      //   },
      //   ]
      // },
      // {
      //   name:'form9',
      //   title: '9.6 ค่าอุปการะเลี้ยงดู คนพิการหรือคนทุพพลภาพคนที่ 6',
      //   borderShow:true,
      //   borderTop:false,
      //   ketForm: 6,
      //   checkArray:"detailTax",
      //   formValue:[
      //     {
      //         label: "ชื่อ - นามสกุล",
      //         keyMapdata: ["employeeName6"],
      //         typeData: "",
      //         value: '',
      //         col: 12,
      //         offset:0,
      //         checkValue:[],
      //     },
      //     {
      //         label: "บัตรคนพิการ",
      //         keyMapdata: ["idCardDisabled6"],
      //         typeData: "",
      //         value: '',
      //         col: 12,
      //         offset:0,
      //         checkValue:[],
      //     },
      //     {
      //         label: "ใช้สิทธิหักลดหย่อน",
      //         keyMapdata: ["lessAllowance6"],
      //         typeData: "money",
      //         value: '',
      //         col: 12,
      //         offset:0,
      //         checkValue:[],
      //     },
      //     {
      //       label: "ความสัมพันธ์",
      //       keyMapdata: ["relation6"],
      //       typeData: "listDropDrownRealtion",
      //       value: '',
      //       col: 12,
      //       offset:0,
      //       checkValue:[],
      //   },
      //   ]
      // },
      // {
      //   name:'form9',
      //   title: '9.7 ค่าอุปการะเลี้ยงดู คนพิการหรือคนทุพพลภาพคนที่ 7',
      //   borderShow:true,
      //   borderTop:false,
      //   ketForm: 7,
      //   checkArray:"detailTax",
      //   formValue:[
      //     {
      //         label: "ชื่อ - นามสกุล",
      //         keyMapdata: ["employeeName7"],
      //         typeData: "",
      //         value: '',
      //         col: 12,
      //         offset:0,
      //         checkValue:[],
      //     },
      //     {
      //         label: "บัตรคนพิการ",
      //         keyMapdata: ["idCardDisabled7"],
      //         typeData: "",
      //         value: '',
      //         col: 12,
      //         offset:0,
      //         checkValue:[],
      //     },
      //     {
      //         label: "ใช้สิทธิหักลดหย่อน",
      //         keyMapdata: ["lessAllowance7"],
      //         typeData: "money",
      //         value: '',
      //         col: 12,
      //         offset:0,
      //         checkValue:[],
      //     },
      //     {
      //       label: "ความสัมพันธ์",
      //       keyMapdata: ["relation7"],
      //       typeData: "listDropDrownRealtion",
      //       value: '',
      //       col: 12,
      //       offset:0,
      //       checkValue:[],
      //   },
      //   ]
      // },
      // {
      //   name:'form9',
      //   title: '9.8 ค่าอุปการะเลี้ยงดู คนพิการหรือคนทุพพลภาพคนที่ 8',
      //   borderShow:true,
      //   borderTop:false,
      //   ketForm: 8,
      //   checkArray:"detailTax",
      //   formValue:[
      //     {
      //         label: "ชื่อ - นามสกุล",
      //         keyMapdata: ["employeeName8"],
      //         typeData: "",
      //         value: '',
      //         col: 12,
      //         offset:0,
      //         checkValue:[],
      //     },
      //     {
      //         label: "บัตรคนพิการ",
      //         keyMapdata: ["idCardDisabled8"],
      //         typeData: "",
      //         value: '',
      //         col: 12,
      //         offset:0,
      //         checkValue:[],
      //     },
      //     {
      //         label: "ใช้สิทธิหักลดหย่อน",
      //         keyMapdata: ["lessAllowance8"],
      //         typeData: "money",
      //         value: '',
      //         col: 12,
      //         offset:0,
      //         checkValue:[],
      //     },
      //     {
      //       label: "ความสัมพันธ์",
      //       keyMapdata: ["relation8"],
      //       typeData: "listDropDrownRealtion",
      //       value: '',
      //       col: 12,
      //       offset:0,
      //       checkValue:[],
      //   },
      //   ]
      // },
      // {
      //   name:'form9',
      //   title: '9.9 ค่าอุปการะเลี้ยงดู คนพิการหรือคนทุพพลภาพคนที่ 9',
      //   borderShow:true,
      //   borderTop:false,
      //   ketForm: 9,
      //   checkArray:"detailTax",
      //   formValue:[
      //     {
      //         label: "ชื่อ - นามสกุล",
      //         keyMapdata: ["employeeName9"],
      //         typeData: "",
      //         value: '',
      //         col: 12,
      //         offset:0,
      //         checkValue:[],
      //     },
      //     {
      //         label: "บัตรคนพิการ",
      //         keyMapdata: ["idCardDisabled9"],
      //         typeData: "",
      //         value: '',
      //         col: 12,
      //         offset:0,
      //         checkValue:[],
      //     },
      //     {
      //         label: "ใช้สิทธิหักลดหย่อน",
      //         keyMapdata: ["lessAllowance9"],
      //         typeData: "money",
      //         value: '',
      //         col: 12,
      //         offset:0,
      //         checkValue:[],
      //     },
      //     {
      //       label: "ความสัมพันธ์",
      //       keyMapdata: ["relation9"],
      //       typeData: "listDropDrownRealtion",
      //       value: '',
      //       col: 12,
      //       offset:0,
      //       checkValue:[],
      //   },
      //   ]
      // },
      // {
      //   name:'form9',
      //   title: '9.10 ค่าอุปการะเลี้ยงดู คนพิการหรือคนทุพพลภาพคนที่ 10',
      //   borderShow:true,
      //   borderTop:false,
      //   ketForm: 10,
      //   checkArray:"detailTax",
      //   formValue:[
      //     {
      //         label: "ชื่อ - นามสกุล",
      //         keyMapdata: ["employeeName10"],
      //         typeData: "",
      //         value: '',
      //         col: 12,
      //         offset:0,
      //         checkValue:[],
      //     },
      //     {
      //         label: "บัตรคนพิการ",
      //         keyMapdata: ["idCardDisabled10"],
      //         typeData: "",
      //         value: '',
      //         col: 12,
      //         offset:0,
      //         checkValue:[],
      //     },
      //     {
      //         label: "ใช้สิทธิหักลดหย่อน",
      //         keyMapdata: ["lessAllowance10"],
      //         typeData: "money",
      //         value: '',
      //         col: 12,
      //         offset:0,
      //         checkValue:[],
      //     },
      //     {
      //       label: "ความสัมพันธ์",
      //       keyMapdata: ["relation10"],
      //       typeData: "listDropDrownRealtion",
      //       value: '',
      //       col: 12,
      //       offset:0,
      //       checkValue:[],
      //   },
      //   ]
      // },
      {
        name:'form11',
        title: '10. เบี้ยประกันชีวิตที่จ่ายภายในปีภาษี (บาท)',
        borderShow:false,
        borderTop:true,
        ketForm: null,
        checkArray:"fetchEmployeeTax",
        formValue:[
          {
              label: "จำนวนเงิน",
              keyMapdata: ["insuraAmount"],
              typeData: "money",
              value: '',
              col: 12,
              offset:0,
              checkValue:[],
          },
        ]
      },
      // {
      //   name:'form11',
      //   title: '10.1 เบี้ยประกันชีวิตคู่สมรส (บาท)',
      //   borderShow:true,
      //   borderTop:null,
      //   ketForm: null,
      //   checkArray:"fetchEmployeeTax",
      //   formValue:[
      //     {
      //         label: "จำนวนเงิน",
      //         keyMapdata: ["spouseInsuraAmnt"],
      //         typeData: "money",
      //         value: '',
      //         col: 12,
      //         offset:0,
      //         checkValue:[],
      //     },
      //   ]
      // },
      {
        name:'form12',
        title: '11. เบี้ยประกันสุขภาพที่จ่ายภายในปีภาษี (บาท)',
        borderShow:true,
        borderTop:false,
        ketForm: null,
        checkArray:"fetchEmployeeTax",
        formValue:[
          {
              label: "จำนวนเงิน",
              keyMapdata: ["HealthInsurance"],
              typeData: "money",
              value: '',
              col: 12,
              offset:0,
              checkValue:[],
          },
        ]
      },
      // {
      //   name:'form13',
      //   title: '12. เบี้ยประกันชีวิตแบบบำนาญ (บาท)',
      //   borderShow:true,
      //   borderTop:false,
      //   ketForm: null,
      //   checkArray:"fetchEmployeeSocialSecurity",
      //   formValue:[
      //     {
      //         label: "จำนวนเงิน",
      //         keyMapdata: ["longInsurance"],
      //         typeData: "money",
      //         value: '',
      //         col: 12,
      //         offset:0,
      //         checkValue:[],
      //     },
      //   ]
      // },
      {
        name:'form13',
        title: '13. กองทุนสำรองเลี้ยงชีพ (บาท)',
        borderShow:true,
        borderTop:false,
        ketForm: null,
        checkArray:"fetchEmployeeSocialSecurity",
        formValue:[
          {
              label: "จำนวนเงิน",
              keyMapdata: ["providentFundTax"],
              typeData: "money",
              value: '',
              col: 12,
              offset:0,
              checkValue:[],
          },
        ]
      },
      {
        name:'form14',
        title: '14. ค่าซื้อหน่วยลงทุนในกองทุนรวมเพื่อการเลี้ยงชีพภายในปีภาษี (บาท)',
        borderShow:true,
        borderTop:false,
        ketForm: null,
        checkArray:"fetchEmployeeTax",
        formValue:[
          {
              label: "จำนวนเงิน",
              keyMapdata: ["rmfDeposit"],
              typeData: "money",
              value: '',
              col: 12,
              offset:0,
              checkValue:[],
          },
        ]
      },
      {
        name:'form15',
        title: '15. กองทุนเพื่อการออม (SSF) (บาท)',
        borderShow:true,
        borderTop:false,
        ketForm: null,
        checkArray:"fetchEmployeeTax",
        formValue:[
          {
              label: "จำนวนเงิน",
              keyMapdata: ["ssfDeposit"],
              typeData: "money",
              value: '',
              col: 12,
              offset:0,
              checkValue:[],
          },
        ]
      },
      {
        name:'form15',
        title: '16. ดอกเบี้ยเงินกู้ยืมเพื่อซื้อ เช่าซื้อ หรือสร้างอาคาร ที่อยู่อาศัย (บาท)',
        borderShow:true,
        borderTop:false,
        ketForm: null,
        checkArray:"fetchEmployeeTax",
        formValue:[
          {
              label: "จำนวนเงิน",
              keyMapdata: ["interestLoan"],
              typeData: "money",
              value: '',
              col: 12,
              offset:0,
              checkValue:[],
          },
        ]
      },
      // {
      //   name:'form16',
      //   title: '17. ซื้ออสังหาริมทรัพย์ (บ้านหลังแรก) (บาท)',
      //   borderShow:true,
      //   borderTop:false,
      //   ketForm: null,
      //   checkArray:"fetchEmployeeTax",
      //   formValue:[
      //     {
      //         label: "จำนวนเงิน",
      //         keyMapdata: ["firstHome"],
      //         typeData: "money",
      //         value: '',
      //         col: 12,
      //         offset:0,
      //         checkValue:[],
      //     },
      //   ]
      // },
      {
        name:'form16',
        title: '18. เงินสมทบกองทุนประกันสังคมภายในปีภาษี (บาท)',
        borderShow:true,
        borderTop:false,
        ketForm: null,
        checkArray:"fetchEmployeeSocialSecurity",
        formValue:[
          {
              label: "จำนวนเงิน",
              keyMapdata: ["accumulateSocial"],
              typeData: "money",
              value: '',
              col: 12,
              offset:0,
              checkValue:[],
          },
        ]
      },
      // {
      //   name:'form17',
      //   title: '19. เงินบริจาคให้สถานพยาบาลรัฐ (บาท)',
      //   borderShow:true,
      //   borderTop:false,
      //   ketForm: null,
      //   checkArray:"fetchEmployeeTax",
      //   formValue:[
      //     {
      //         label: "จำนวนเงิน",
      //         keyMapdata: ["donationHospital"],
      //         typeData: "money",
      //         value: '',
      //         col: 12,
      //         offset:0,
      //         checkValue:[],
      //     },
      //   ]
      // },
      {
        name:'form17',
        title: '20. เงินบริจาคสนับสนุนการศึกษา (บาท)',
        borderShow:true,
        borderTop:false,
        ketForm: null,
        checkArray:"fetchEmployeeTax",
        formValue:[
          {
              label: "จำนวนเงิน",
              keyMapdata: ["DonationEducate"],
              typeData: "money",
              value: '',
              col: 12,
              offset:0,
              checkValue:[],
          },
        ]
      },
      {
        name:'form16',
        title: '21. บริจาคเงินเพื่อการกุศล (บาท)',
        borderShow:true,
        borderTop:false,
        ketForm: null,
        checkArray:"fetchEmployeeTax",
        formValue:[
          {
              label: "",
              keyMapdata: ["DonationCharity"],
              typeData: "money",
              value: '',
              col: 12,
              offset:0,
              checkValue:[],
          },
        ]
      },
    ]
  },
}